export enum LAYOUT {
  BACK_OFFICE = 'back-office',
  DEFAULT = 'default',
  EMPTY = 'empty',
  AUTH = 'auth',
  PUBLIC = 'public',
  ACCOUNT = 'account',
}
